import React from "react";
import { StyledLabelStack } from "./styles";
import { Typography } from "@mui/material";

const ScheduleDates = ({ elements = [] }) => {
  return (
    <StyledLabelStack>
      {elements?.map(({ id, label }) => (
        <Typography variant="caption" key={id}>
          {label}
        </Typography>
      ))}
    </StyledLabelStack>
  );
};

export default ScheduleDates;
